import { validationRuleAtoms } from '~/src/shared/validationRuleAtoms';

const { validateRequired } = validationRuleAtoms;
export const classroomValidationRules = {
  classroomValidationRule: {
    classroom: [validateRequired('教室')]
  }
} as const;
